// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type PromptTemplate } from "../../api";
import { useGetAufgabePromptTemplate as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useAufgabePromptTemplateQueryKey(
  languagecode: string
): QueryKey {
  return ["api", "v1", "aufgaben", "getprompttemplate", languagecode];
}

export function useAufgabePromptTemplate(
  languagecode: string,
  options: Omit<
    UseQueryOptions<PromptTemplate, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): PromptTemplate {
  const getter = useGetter();
  return useQuery(
    useAufgabePromptTemplateQueryKey(languagecode),
    () => getter(languagecode),
    options
  ).data!;
}
